<template>
    <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
      <!-- Side Menu -->
      <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
        <!-- Top Menu -->
        <div class="sticky top-0 bg-[#090446] p-4 z-20">
          <div>
            <p class="text-lg font-semibold">Total Progress: {{
                        progressDetail.totalAnswers1}}/{{
                            progressDetail.totalQuestions1}}
            </p>
            <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                <div class="bg-[#ab064e] h-2.5 rounded-full"
                    :style="{ width: ((progressDetail.totalAnswers1) / (progressDetail.totalQuestions1)) * 100 + '%' }">
                </div>
            </div>
          </div>
        </div>
  
        <!-- Bottom Menu -->
        <div class="mt-auto">
          <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
            Privacy Policy
          </router-link>
        </div>
      </div>
  
      <!-- Main Content -->
      <div class="flex-1 flex flex-col items-center py-6 md:px-16 px-4 z-0">
        <!-- Instructions Card -->
        <div id="instructions-card" class="bg-white text-black p-6 rounded-lg shadow-lg mb-6 w-full lg:w-3/4">
          <div class="flex items-center justify-center mb-4">
            <a href="#" class="flex items-center">
              <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
            </a>
          </div>
          <div>
            <p class="text-lg text-black mb-4">
                Thank you for completing the <strong> Change and Ambiguity Assessment</strong>!
            </p>
            <p class="text-lg text-black mb-4">
                We appreciate you taking the time to reflect on your responses. Based on your answers, you'll receive a personalized <strong>report</strong> summarizing your results, including insights on your comfort with ambiguity and how you approach change.
            </p>
            <p class="text-lg text-black mb-4">
                <strong>Next Steps:</strong>
                <ul>
                    <li>• Your report will be delivered to you shortly via email (be sure to check spam).</li>
                    <li>• We encourage you to review the results and consider how they might help you in navigating change.</li>
                </ul>
            </p>
            <p class="text-lg text-black mb-4">If you have any questions or would like to learn more about how to interpret your results, feel free to reach out to admin@mpact-int.com.</p>
            
            <!-- Download Report Button -->
            <div class="flex justify-center mt-6">
              <button
                class="flex items-center px-8 py-3 rounded-md bg-[#0A0446] text-white text-center text-lg shadow hover:bg-[#0A0446]/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                @click="downloadScoreReport"
                :disabled="isDownloading || !assessmentId">
                <svg v-if="isDownloading" class="animate-spin h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span>{{ isDownloading ? 'Downloading...' : 'Download My Report' }}</span>
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  </template>
  
  
  <script>
  import Swal from 'sweetalert2'
  import Api from '../router/api'
  import AppMixin from '../mixins/AppMixin'
  import { ASSET_BE_URL } from '../constants';
  
  export default {
    name: 'NonEmployeeSurveyTwo',
    data() {
      return {
        url: '',
        questions: [],
        selectedAnswers: {},
        progressDetail: {
          totalQuestions1: 0,
          totalAnswers1: 0,
        },
        isDownloading: false,
        assessmentId: null
      }
    },
    mounted() {
      let urlToken = this.$route.fullPath.split('/')[2]
      this.url = urlToken
      this.getProgressBarDetail(this.url)
      this.getNonEmployeeStep(this.url)
    },
    computed: {
      progress() {
        // Calculate the progress percentage
        return (Object.keys(this.selectedAnswers).length / this.questions.length) * 100;
      }
    },
    methods: {
      getProgressBarDetail(url) {
          Api.getAssessmentProgress(url).then(response => {
              console.log(response.data.res);
              this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
              this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
          });
      },
      
      getNonEmployeeStep(token) {
          Api.getNonEmployeeStep(token).then(response => {
              console.log('Assessment data:', response.data.res);
              // Get the assessment ID from the response
              if (response.data.res && response.data.res.id) {
                this.assessmentId = response.data.res.id;
              }
          }).catch(error => {
              console.error('Error fetching assessment data:', error);
          });
      },
      
      downloadScoreReport() {
        if (!this.assessmentId) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Assessment ID not available for download. Please try again.",
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          });
          return;
        }

        this.isDownloading = true;
        
        // Create the PDF URL using the assessment ID
        const pdfUrl = `${ASSET_BE_URL}/view-assessment-pdf/${this.assessmentId}`;
        
        // Create a temporary link element to trigger download
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.download = `my-assessment-report.pdf`;
        
        // Append to document, click, and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Reset downloading state after a short delay
        setTimeout(() => {
          this.isDownloading = false;
        }, 2000);
      }
    }
  }
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/components/AssessmentComplete.vue